import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiTableCell = {
  styleOverrides: {
    root: {
      borderBottom: 'var(--TableCell-borderWidth, 1px) solid #E4E7EC',
      padding: '10px 14px',
    },
    head: {
      fontSize: '0.75rem',
      fontWeight: 700,
      letterSpacing: 0,
      textTransform: 'uppercase',
    },
    body: {
      fontSize: '0.8125rem',
    },
    paddingCheckbox: { padding: '0 0 0 24px' },
  },
} satisfies Components<Theme>['MuiTableCell'];
